export default {
  versionName: 'Munster Athletics Production Portal',
  versionNumber: '1.0.0',
  baseUrl: 'https://munsterathletics.com',
  apiUrl: 'https://munsterathletics.com/munster/v1',
}